import { IconSvg, IconSvgProps } from "./icon"

export default function Minus(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M3.643 12h16.714" />
    </IconSvg>
  )
}
